module.exports = __webpack_public_path__ + "static/img/banner_en.ba7818d.png";


//////////////////
// WEBPACK FOOTER
// ./static/mobile/banner_en.png
// module id = mCdR
// module chunks = 2